import isCypress from '@signal/utils/env/isCypress'

export const props = {
  MuiButtonBase: {
    disableRipple: isCypress()
  }
}

export default props
